import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/home/polymerize/keywords',
    owner: '/home',
    authority: 'newsflashKeywordList',
    component: Loadable({
      loader: () => import('./index'),
      loading: () => <RouteLoading />
    })
  },
];